import {HTTP_REQUEST_METHODS} from "@js/constants/js-constants.es6.js";

export default class ApiErrorHandler {
  /**
   * Represents an failed API call.
   * @constructor
   * @param {string} statusCode the status code for the HTTP response
   * @param {string} statusText the status text for the HTTP response
   * @param {string} method the method for the HTTP request
   * @param {string} path the path for the HTTP request
   * @param {string} body the body for the HTTP request
   * @param clientErrorMessage a client error message to send for additional information
   * @param redirectPage a page to redirect to on error (not required)
   */
  static handleError(statusCode, statusText, method, path, body, clientErrorMessage, redirectPage) {
    let message = `[${statusCode}/${statusText}] ${method} ${path}`;

    if (body) {
      message += ` (response: ${JSON.stringify(body)})`;
    }

    // eslint-disable-next-line no-console
    console.error(message);
    if (clientErrorMessage) {
      // eslint-disable-next-line no-console
      console.error(clientErrorMessage);
    }

    if (redirectPage) {
      window.location = redirectPage;
    }

    // In the case of PUT, DELETE, POST we do not want to fail gracefully
    if (method !== HTTP_REQUEST_METHODS.GET) {
      throw Error(`Method ${method} has failed: ${message}`);
    }
  }
}
